// TASK SUPPORT REQUEST
export const taskRequestCreate = 'TASK_REQUEST.allowCreate'
export const taskRequestRead = 'TASK_REQUEST.allowRead'
export const taskRequestUpdate = 'TASK_REQUEST.allowUpdate'
export const taskRequestDelete = 'TASK_REQUEST.allowDelete'

// TASK CONFORMITY REPORT
export const taskUnconformityCreate = 'TASK_UNCONFORMITY.allowCreate'
export const taskUnconformityRead = 'TASK_UNCONFORMITY.allowRead'
export const taskUnconformityUpdate = 'TASK_UNCONFORMITY.allowUpdate'
export const taskUnconformityDelete = 'TASK_UNCONFORMITY.allowDelete'

// MENUS
export const performanceRead = 'PERFORMANCE.allowRead'
export const checklistRead = 'CHECKLIST.allowRead'
export const reportRead = 'REPORT.allowRead'
export const taskRead = 'TASK.allowRead'
export const dataValidationRead = [
  'CONTRACTOR_REPORT_RAIN_AND_SLIPPERY.allowRead',
  'CONTRACTOR_REPORT_OVERBURDEN.allowRead',
]
export const userLogRead = 'AUDIT_LOG.allowRead'

// DASHBOARD
export const dashboardCreate = 'DASHBOARD.allowCreate'
export const dashboardRead = 'DASHBOARD.allowRead'
export const dashboardUpdate = 'DASHBOARD.allowUpdate'
export const dashboardDelete = 'DASHBOARD.allowDelete'

// CHECKLIST COAL WINNING
export const checklistCoalWinningCreate = 'CHECKLIST_COAL_WINNING.allowCreate'
export const checklistCoalWinningRead = 'CHECKLIST_COAL_WINNING.allowRead'
export const checklistCoalWinningUpdate = 'CHECKLIST_COAL_WINNING.allowUpdate'
export const checklistCoalWinningDelete = 'CHECKLIST_COAL_WINNING.allowDelete'

// CHECKLIST OB REMOVAL
export const checklistObRemovalCreate = 'CHECKLIST_OB_REMOVAL.allowCreate'
export const checklistObRemovalRead = 'CHECKLIST_OB_REMOVAL.allowRead'
export const checklistObRemovalUpdate = 'CHECKLIST_OB_REMOVAL.allowUpdate'
export const checklistObRemovalDelete = 'CHECKLIST_OB_REMOVAL.allowDelete'

// CHECKLIST DUMPING ACTIVITY
export const checklistDumpingCreate = 'CHECKLIST_DUMPING.allowCreate'
export const checklistDumpingRead = 'CHECKLIST_DUMPING.allowRead'
export const checklistDumpingUpdate = 'CHECKLIST_DUMPING.allowUpdate'
export const checklistDumpingDelete = 'CHECKLIST_DUMPING.allowDelete'

// CHECKLIST SUPPORT EQUIPMENT
export const checklistSupportEQCreate =
  'CHECKLIST_SUPPORT_EQUIPMENT.allowCreate'
export const checklistSupportEQRead = 'CHECKLIST_SUPPORT_EQUIPMENT.allowRead'
export const checklistSupportEQUpdate =
  'CHECKLIST_SUPPORT_EQUIPMENT.allowUpdate'
export const checklistSupportEQDelete =
  'CHECKLIST_SUPPORT_EQUIPMENT.allowDelete'

// CHECKLIST BLASTING ACTIVITY
export const checklistBlastingCreate = 'CHECKLIST_BLASTING.allowCreate'
export const checklistBlastingRead = 'CHECKLIST_BLASTING.allowRead'
export const checklistBlastingUpdate = 'CHECKLIST_BLASTING.allowUpdate'
export const checklistBlastingDelete = 'CHECKLIST_BLASTING.allowDelete'

// CHECKLIST RAIN AND SLIPPERY
export const checklistRainfallCreate = 'CHECKLIST_RAINFALL.allowCreate'
export const checklistRainfallRead = 'CHECKLIST_RAINFALL.allowRead'
export const checklistRainfallUpdate = 'CHECKLIST_RAINFALL.allowUpdate'
export const checklistRainfallDelete = 'CHECKLIST_RAINFALL.allowDelete'

// CHECKLIST COAL INVENTORY
export const checklistCoalInventoryCreate =
  'CHECKLIST_COAL_INVENTORY.allowCreate'
export const checklistCoalInventoryRead = 'CHECKLIST_COAL_INVENTORY.allowRead'
export const checklistCoalInventoryUpdate =
  'CHECKLIST_COAL_INVENTORY.allowUpdate'
export const checklistCoalInventoryDelete =
  'CHECKLIST_COAL_INVENTORY.allowDelete'

// CHECKLIST HM DAY WORK
export const checklistHMDWorkCreate = 'CHECKLIST_HM_DAY_WORK.allowCreate'
export const checklistHMDWorkRead = 'CHECKLIST_HM_DAY_WORK.allowRead'
export const checklistHMDWorkUpdate = 'CHECKLIST_HM_DAY_WORK.allowUpdate'
export const checklistHMDWorkDelete = 'CHECKLIST_HM_DAY_WORK.allowDelete'

// CHECKLIST EFFECTIVE WORKING HOUR
export const checklistEWHCreate = 'CHECKLIST_EFFECTIVE_WORKING_HOUR.allowCreate'
export const checklistEWHRead = 'CHECKLIST_EFFECTIVE_WORKING_HOUR.allowRead'
export const checklistEWHUpdate = 'CHECKLIST_EFFECTIVE_WORKING_HOUR.allowUpdate'
export const checklistEWHDelete = 'CHECKLIST_EFFECTIVE_WORKING_HOUR.allowDelete'

// ACTUAL LOADING
export const actualLoadingCreate = 'BARGE_LOADING.allowCreate'
export const actualLoadingRead = 'BARGE_LOADING.allowRead'
export const actualLoadingUpdate = 'BARGE_LOADING.allowUpdate'
export const actualLoadingDelete = 'BARGE_LOADING.allowDelete'
export const actualLoadingAcknowledge = 'BARGE_LOADING.allowAcknowledge'

// BLASTING REPORT
export const blastingReportCreate = 'BLASTING_REPORT.allowCreate'
export const blastingReportRead = 'BLASTING_REPORT.allowRead'
export const blastingReportUpdate = 'BLASTING_REPORT.allowUpdate'
export const blastingReportDelete = 'BLASTING_REPORT.allowDelete'
export const blastingReportApproval = 'BLASTING_REPORT.allowApproval'

// GROUP MANAGEMENT
export const groupRead = 'GROUP.allowRead'
export const groupCreate = 'GROUP.allowCreate'
export const groupUpdate = 'GROUP.allowUpdate'

// COMPANY
export const companyRead = 'COMPANY.allowRead'

// CONTRACTOR
export const contractorRead = 'CONTRACTOR.allowRead'

// BEK REPORT
export const BEKReportRead = 'BEK_REPORT.allowRead'

// IMM REPORT
export const IMMReportRead = 'IMM_REPORT.allowRead'

// BARGE CHECKLIST REPORT
export const reportBargeChecklistRead = 'REPORT_BARGE_CHECKLIST.allowRead'

// DATA VALIDATION
export const contractorReportOBCreate =
  'CONTRACTOR_REPORT_OVERBURDEN.allowCreate'
export const contractorReportOBRead = 'CONTRACTOR_REPORT_OVERBURDEN.allowRead'
export const contractorReportOBUpdate =
  'CONTRACTOR_REPORT_OVERBURDEN.allowUpdate'
export const contractorReportOBDelete =
  'CONTRACTOR_REPORT_OVERBURDEN.allowDelete'
export const contractorReportOBApprove =
  'CONTRACTOR_REPORT_OVERBURDEN.allowApproval'

export const contractorReportRSCreate =
  'CONTRACTOR_REPORT_RAIN_AND_SLIPPERY.allowCreate'
export const contractorReportRSRead =
  'CONTRACTOR_REPORT_RAIN_AND_SLIPPERY.allowRead'
export const contractorReportRSUpdate =
  'CONTRACTOR_REPORT_RAIN_AND_SLIPPERY.allowUpdate'
export const contractorReportRSDelete =
  'CONTRACTOR_REPORT_RAIN_AND_SLIPPERY.allowDelete'
export const contractorReportRSApprove =
  'CONTRACTOR_REPORT_RAIN_AND_SLIPPERY.allowApproval'

export const contractorReportOutpitRSCreate =
  'CHECKLIST_OUTPIT_RAINFALL.allowCreate'
export const contractorReportOutpitRSRead =
  'CHECKLIST_OUTPIT_RAINFALL.allowRead'
export const contractorReportOutpitRSUpdate =
  'CHECKLIST_OUTPIT_RAINFALL.allowUpdate'
export const contractorReportOutpitRSDelete =
  'CHECKLIST_OUTPIT_RAINFALL.allowDelete'
export const contractorReportOutpitRSApprove =
  'CHECKLIST_OUTPIT_RAINFALL.allowApproval'

// CHECKLIST OUTPIT WORK
export const outpitWorkCreate = 'CHECKLIST_OUTPIT_WORK.allowCreate'
export const outpitWorkRead = 'CHECKLIST_OUTPIT_WORK.allowRead'
export const outpitWorkUpdate = 'CHECKLIST_OUTPIT_WORK.allowUpdate'
export const outpitWorkDelete = 'CHECKLIST_OUTPIT_WORK.allowDelete'
export const outpitWorkApprove = 'CHECKLIST_OUTPIT_WORK.allowApproval'

// CHECKLIST PUMPING PROGRESS
export const pumpingProgressCreate = 'CHECKLIST_PUMPING_PROGRESS.allowCreate'
export const pumpingProgressRead = 'CHECKLIST_PUMPING_PROGRESS.allowRead'
export const pumpingProgressUpdate = 'CHECKLIST_PUMPING_PROGRESS.allowUpdate'
export const pumpingProgressDelete = 'CHECKLIST_PUMPING_PROGRESS.allowDelete'
export const pumpingProgressApprove = 'CHECKLIST_PUMPING_PROGRESS.allowApproval'

// STOCK OPNAME
export const stockOpnameCreate = 'STOCK_OPNAME.allowCreate'
export const stockOpnameRead = 'STOCK_OPNAME.allowRead'
export const stockOpnameUpdate = 'STOCK_OPNAME.allowUpdate'
export const stockOpnameDelete = 'STOCK_OPNAME.allowDelete'
export const stockOpnameAcknowledge = 'STOCK_OPNAME.allowAcknowledge'